module.exports = __webpack_public_path__ + "static/media/prb-nutri-brinde-caneta-personalizado.4bbec382.jpg";